import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SORT_DIRECTION } from '../../../util/CrosstabUtils';
import * as mmeUtils from '../../../util/MMEUtils';

class MMEDCRColumnHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      header: props.header,
      editEnabled: false,
    };
  }

  onPrivateEyeSort = (key, columnIndex) => {
    let sortOrder = SORT_DIRECTION.DESC;
    if (
      this.props.sortColumnIndex === columnIndex &&
      this.props.sortKey === key
    ) {
      switch (this.props.sortOrder) {
        case SORT_DIRECTION.DESC:
          sortOrder = SORT_DIRECTION.ASC;
          break;
        case SORT_DIRECTION.ASC:
          sortOrder = SORT_DIRECTION.NONE;
          break;
        default:
          sortOrder = SORT_DIRECTION.DESC;
      }
    }
    this.props.onSort(sortOrder, key, columnIndex);
  };

  getClassName = count => {
    switch (count) {
      case 1: return { width: '100%' };
      case 2: return { width: '50%' };
      case 3: return { width: '33.3%' };
      case 4: return { width: '25%' };
      case 5: return { width: '20%' };
      default: return { width: '0%' };
    }
  }

  render() {
    const {
      metricsList, metricsCount, sortOrder, sortKey, columnIndex, sortColumnIndex, allRowValues,
    } = this.props;
    const { header } = this.state;
    return (
      <div className={header.isSelected ? 'c-table--col--selected' : 'c-table--col'}>
        <div className="title-container">
          {!this.state.editEnabled && <div>
            <div
              className="title-btn"
              title={`${header.tooltipVal ? header.tooltipVal : header.label} ${
                header.isColumnLabelUpdated ? String.fromCharCode(185) : ''
              }`}
            >{header.label}<sup>{header.isColumnLabelUpdated ? '1' : ''}</sup></div>
            <div className="mme-col-header-color" style={mmeUtils.getColumnRowColor(header.colorVal)} />
          </div>}
        </div>
        {header.label !== '' && <div className="cell mme-first-cell">
          {metricsList && metricsList.map(item => (<div key={`${item.label}-${item.key}`}
            className="cell--item" title={item.label} style={this.getClassName(metricsCount)}>
            <button
              type="button"
              id={`${item.key}-header${columnIndex}`}
              onClick={() => this.onPrivateEyeSort(item.key, columnIndex)}
              className="mme-column-text"
            >{item.text}
              {sortKey === item.key && sortOrder === 'desc' && sortColumnIndex === columnIndex && <i data-test="desc">
                ▼</i>}
              {sortKey === item.key && sortOrder === 'asc' && sortColumnIndex === columnIndex && <i data-test="asc">
                ▲</i>}
            </button>
          </div>))}
        </div>}
        {header.label !== '' && <div className="cell mme-all-rows-right-cell">
          <div className="all-row-right-cell" title={`${allRowValues.s0}%`}>{allRowValues.s0}%</div>
          <div className="all-row-right-cell" title={`${allRowValues.s1}%`}>{allRowValues.s1}%</div>
          <div className="all-row-right-cell" title={`${allRowValues.s2}%`}>{allRowValues.s2}%</div>
          <div className="all-row-right-cell" title={`${allRowValues.s3}%`}>{allRowValues.s3}%</div>
        </div>}
      </div>
    );
  }
}

MMEDCRColumnHeader.propTypes = {
  metricsList: PropTypes.arrayOf(PropTypes.shape({})),
  metricsCount: PropTypes.number,
  columnIndex: PropTypes.number,
  sortColumnIndex: PropTypes.number,
  sortOrder: PropTypes.string,
  sortKey: PropTypes.string,
  onSort: PropTypes.func,
  header: PropTypes.shape({}),
  allRowValues: PropTypes.shape({
    s0: PropTypes.number,
    s1: PropTypes.number,
    s2: PropTypes.number,
    s3: PropTypes.number,
  }),
};

export default MMEDCRColumnHeader;
